import { Flex, Box } from "@chakra-ui/react";
import Navbar from "./pages/Navbar";
import Main from "./pages/Main";
import MoreInfo from "./pages/MoreInfo";
import About from "./pages/About";
import Questions from "./pages/Questions";
import Footer from "./pages/Footer";

function App() {
  return (
    <>
      <Flex
        direction="column"
        width={{ base: "100%", sm: "100%", md: "100%", lg: "auto", xl: "1146px" }}
        justifyContent={"center"}
        margin="auto"
        padding={"0px 30px"}
      >
        <Box as="section" minHeight={{base: "auto", md: "100vh"}}>
          <Navbar />
          <Main />
        </Box>
        {/* <Box as="section" height="100vh"> */}
          <MoreInfo />
        {/* </Box> */}
        {/* <Box as="section" height="100vh"> */}
          <About />
          <Questions />
        {/* </Box> */}
      </Flex>
      <Footer />
    </>
  );
}

export default App;
